import React from 'react';
import {LinkCompat as Link, ILinkProps} from 'components/FluentUICompat';

export const CellLink = (props: ILinkProps) => {
	/**
	 * We disable tabbing to this item because each Details List's row is
	 * focusable. So, users would have to press "Tab" twice to advance to the next
	 * item.
	 */
	return <Link tabIndex={-1} {...props} />;
};
